import { useEffect, useState } from "react";
import api from "../api/axios";

const useUser = () => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUsrInfo = async() => {
      try {
        setError("");

        const res = await api.get("/auth/me");
        setUser(res.data);
      }catch(err){
        console.error(err);
        if(err.response && err.response.data && err.response.data.message) {
          setError(err.response.data.message);
        }else{
          setError("Failed to load user information!");
        }
        }finally{
        setLoading(false); 
      }
    };
    getUsrInfo();
  }, []);
  return {user, error, loading };
}

export default useUser;